import {Button, Col, ContentContainer, Heading, Row} from '@snsw-gel/react';
import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import routes from '../../routes';
import {PhoneElement} from '../../utils/elements';
import { IconNotificationError } from '@snsw-gel/react';
import useClearTrace from '../../hooks/useClearTrace';

const UnableToProcessRequest = () => {
    const history = useHistory();
    const clearTrace = useClearTrace();

    useEffect(() => {
        clearTrace();
    }, []);

    const handleTryAgain = (e) => {
        history.replace(routes.manageTollAccount.path);
    };

    return (
        <ContentContainer>
            <Heading level={1}><IconNotificationError size={28}/> Unable to process your request</Heading>
            <Row>
                <Col>
                    <p>You're currently not logged in or your session may have expired.</p>
                    <p>Please try again. If the issue keeps happening, call {PhoneElement}.</p>
                </Col>
            </Row>

            <div style={{marginTop: '2rem'}}>
                <Button onClick={handleTryAgain} style={{margin: '0 1.5rem 1.2rem 0'}}>
                    Try again
                </Button>

                <Button variant='secondary' href='https://www.service.nsw.gov.au'>
                    Go to homepage
                </Button>
            </div>
        </ContentContainer>
    );
};

export default UnableToProcessRequest;
